<template>
  <div>
    <div class="table-wrapper">
      <div class="input-group-append new_work_center">
        <button
          class="btn btn-primary"
          type="button"
          @click="createWorkCenter"
        >{{$t('work_centers_table.new_work_center')}}</button>
      </div>
      <div class="progress-wrapper">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
      </div>
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div
            class="rTableHead"
            v-for="(header, i) in headers"
            :key="i"
            :style="{ 'width': header.width + '%'}"
          >{{header.text}}</div>
        </div>
        <div class="rTableRow" v-for="(center, i ) in workCenters" :key="i">
          <div class="rTableCell">
            <span>{{ center.code }}</span>
            <span v-if="center.preperation">*</span>
            <span v-if="center.deleted">
              <v-icon small class="mr-2">delete</v-icon>
            </span>
          </div>
          <div class="rTableCell">{{ center.description }}</div>
          <div class="rTableCell number-cell">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small class="mr-2" v-on="on" @click="editWorkCenter(center)">edit</v-icon>
              </template>
              <span>{{ $t("work_centers_table.edit") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small class="mr-2" v-on="on" @click="viewWorkCenter(center)">fullscreen</v-icon>
              </template>
              <span>{{ $t("work_centers_table.watch") }}</span>
            </v-tooltip>
          </div>
        </div>
      </div>
    </div>
    <WorkCenterEditor
      ref="workCenterEditor"
      @workCenterUpdated="updated"
      @workCenterCreated="updated"
    ></WorkCenterEditor>
  </div>
</template>

<script>
import WorkCenterEditor from "@/components/production-planning/WorkCenterEditor.vue";
export default {
  props: ["workCenters"],
  components: {
    WorkCenterEditor,
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: this.$t("work_centers_table.code"),
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: this.$t("work_centers_table.description"),
          align: "left",
          value: "calories",
          sortable: false,
        },
        {
          text: this.$t("work_centers_table.actions"),
          value: "name",
          align: "left",
          sortable: false,
        },
      ],
      centers: [],
      dialog: false,
    };
  },

  methods: {
    updated() {
      this.$emit("updated");
    },

    createWorkCenter() {
      this.$refs.workCenterEditor.openCreate();
    },

    editWorkCenter(center) {
      this.$refs.workCenterEditor.openEdit(center, this.workCenters);
    },

    viewWorkCenter(center) {
      this.$router.push({
        name: "work-center",
        params: { id: center.id, code: center.code },
      });
    },
  },
};
</script>

<style scoped>
.new_work_center {
  position: absolute;
  top: -40px;
  right: 20px;
}
</style>